import {  Component,OnDestroy, OnInit } from '@angular/core';
import { ProcesoReporte } from '../../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { FormBuilder, Validators } from '@angular/forms';
import { IHeader, Pdf } from 'src/app/clases/pdf';
import { XlsxService } from 'src/app/services/utils/xlsx.service';
import { tarjetasCreditoActualizadas } from 'src/app/services/seguimiento/tarjetas-credito-actualizadas.service';


@Component({
  selector: 'app-tarjetas-credito-actualizadas',
  templateUrl: './tarjetas-credito-actualizadas.component.html',
  styleUrls: ['./tarjetas-credito-actualizadas.component.scss']
})
export class TarjetasCreditoActualizadasComponent extends ProcesoReporte implements OnInit {

  grafico !: Highcharts.Chart | undefined | any;
  mostrarGrafico : boolean = false;
  totalDuracionLlamadas = 0;
  totalTiempoLlamada = 0;
  totalPromedio = 0;
  totalLlamadas = 0; 
  pantallaCompletaGrafico : boolean = false;
  //'MMIRANDA','ANOGUERA','LMONTIEL','NARCE','ALUGO'

  recuperadores: Record< string, any >[] = [];
  resumenRecuperadores: Record< string, any >[] = [];
  datosAnteriores: Record< string, any >[] = [];
  cantidadTarjetasActualizadas
  tarjetasEnVista = 0;
  progresoCarga: number = 0;
  getAllTarjetasActualizadas : boolean = false;
  procesandoTarjetas : boolean = false;

  constructor(
    public app: AppComponent, 
    private breadcrumbService: AppBreadcrumbService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private xlsxService : XlsxService,
    private tarjetasCreditoActualizadasService: tarjetasCreditoActualizadas,
  ) {
    super();
    this.crearFormulario();
    this.breadcrumbService.setItems([ { label: 'Gestion de Cobros' } ]);
  }
  ngOnInit(): void {
  }

  async crearFormulario() {
    
    this.formGroup = this.fb.group({
      nro_documento: [ null, Validators.required ]
    });
  }

  async ejecutar(){
    this.items = [];
    this.getAllTarjetasActualizadas = false;
    this.procesandoTarjetas = true;
    const value = this.formGroup.getRawValue();
    try {
        const filtros = {
          nro_cedula: this.formGroup.getRawValue().nro_documento
        }    
        this.loading = true;
        const respuesta = await this.tarjetasCreditoActualizadasService.getTarjetasCreditoActualizadas( filtros );
        this.items = respuesta.resp;
        this.loading = false;

        // await this.getTotalTarjetas( Number( respuesta.resp.totalTarjetas ) );
        // this.getAllTarjetasActualizadas = true;
        // this.procesandoTarjetas = false;
        if( respuesta.resp.length === 0 ){
          this.messageService.add({severity: 'info', 'summary': 'No se encontraron tarjetas'})
        }
    } catch (error: any) {
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer las tarjetas'})
        console.error( error )
        this.loading = false;
    }
  }
  
  traducirCondicion( condicion: boolean ) : string {
    return condicion ? 'Si' : 'No';
  }

  async descargar() {
      const pdf = new Pdf(this.currentUser);
      const value = this.formGroup.getRawValue();
      pdf.title =  `Informe de Tarjetas de credito - CABAL`;
              pdf.headers = [
            { label: 'Nro. Cuenta', name: 'numero_cuenta', type: 'text' },
            { label: 'Tarjeta', name: 'numero_tarjeta', type: 'text' },
            { label: 'Nro. Documento', name: 'documento', type: 'number' },
            { label: 'Nombre de Cliente', name: 'nombre_usuario', type: 'text' },
            { label: 'Fecha ultimo Pago', name: 'fecha_ultimo_pago', type: 'date' },
            { label: 'Grupo afinidad', name: 'desc_grupo_af', type: 'text' },
            { label: 'Deuda Total', name: 'deuda_a_la_fecha', type: 'number' },
            { label: 'Pago minimo', name: 'importe_pago_minimo', type: 'number' },
            { label: 'Principal', name: 'tj_principal', type: 'text' },
            { label: 'Vencimiento', name: 'vencimiento_tar', type: 'text' },
            // { label: 'Actualizado', name: 'actualizado', type: 'text' },
        ]
        for (const item of this.items) {
            // item['agendar_pago'] = await this.traducirCondicion( value.agendar_pago );
            // item['generar_act_nota'] = await this.traducirCondicion( value.generar_act_nota );
            // item['confirmacion_compromiso'] = await this.traducirCondicion( value.confirmacion_compromiso );
            // item['reagendar_llamada'] = await this.traducirCondicion( value.reagendar_llamada );
            // item['confirmacion_cobro'] = await this.traducirCondicion( value.confirmacion_cobro );
            pdf.addSource({ 
                data: item,
            });
        }
        pdf.exportar();
  }
  async descargarExcel() {
      const datos: Record<string, any>[] = [];
      const value = this.formGroup.getRawValue();
      for (const item of this.items) {
        datos.push({
          'Nro. Cuenta': item.numero_cuenta,
          'Tarjeta': item.numero_tarjeta,
          'Nro. Documento': item.documento,
          'Nombre de Cliente': item.nombre_usuario,
          'Fecha ultimo Pago': this.datePipe.transform( item.fecha_ultimo_pago, 'dd/MM/yyyy' ),
          'Grupo afinidad': item.desc_grupo_af,
          'Deuda Total': item.deuda_a_la_fecha,
          'Pago minimo':  item.importe_pago_minimo,
          'Principal': item.tj_principal,
          'Vencimiento': item.vencimiento_tar,
        })
      }
      await this.xlsxService.exportAsExcelFile(datos, `tarjetas_actualizadas_cabal`);
  }

}

interface ITarjeta {
  nombre_usuario: string;
  fecha_vigencia: string;
  vencimiento_tar: string;
  estado: string;
  desc_estado: string;
  deuda_al_cierre: string;
  ultimo_periodo_cerrado: string;
  fecha_vencimiento_pago_minimo: string;
  importe_pm_facturado: string;
  deuda_a_la_fecha: string;
  pagos: string;
  importe_ultimo_pago: string;
  limite_adelanto_olpy: string;
  disponible_normal: string;
  cant_adicionales: string;
  importe_pago_minimo: string;
  dias_en_mora: string;
  disponible_adelanto: string;
  periodo_actual_tarjeta: string;
  cierre: string;
  fecha_ultimo_pago: string;
  actualizado: boolean;
}